import React from 'react';
import clsx from "clsx";
import PropTypes from "prop-types";
import { WhatsappButton } from '../../components';

export const Empty = (props) => {
  const { className, disabledWhatsapp = false } = props;
  return (
    <div className={clsx("viewport-container-1200", className)}>
      {props.children}
      {!disabledWhatsapp && <WhatsappButton />}
    </div>
  );
};

Empty.propTypes = {
  className: PropTypes.string
}

Empty.defaultProps = {}

export default Empty;